import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiEndPoint } from 'src/configurations/constants';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  httpOptions;
  httpBoday = '';
  public userRole: BehaviorSubject<any> = new BehaviorSubject<any>('');

  constructor(private http: HttpClient) { }

  loginCheck(userData): Observable<any> {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        username: userData.username,
        password: userData.password,
        apikey: 'BA2D16C7-6B3A-4447-81D5-497F80E6ADB9',
        'language-iso': 'en',
      }),
    };
    
    return this.http.post<any>(ApiEndPoint.authorize, userData, this.httpOptions).pipe(
      tap(
        (user) => {
          // console.log(user);
        },
        (err) => {
          // console.log(err);
        }
      )
    );
  }

  is_loggedIn() {
    return !!localStorage.getItem('token');
  }

  socialLogin(userData): Observable<any> {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        //'authorization': token,
        'language-iso': 'en',
      }),
    };

    return this.http.post<any>(ApiEndPoint.socialLogin, userData, this.httpOptions);
  }

  getPreferenceData(): Observable<any> {
    const token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        authorization: token,
        'language-iso': 'en',
      }),
    };

    return this.http.get(ApiEndPoint.Users.preference, this.httpOptions);
  }

  googleAuthentication() {
    return this.http.get<any>(`https://accounts.google.com/o/oauth2/auth?scope=https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/plus.me https://www.googleapis.com/auth/user.gender.read https://mail.google.com/ https://www.googleapis.com/auth/gmail.modify https://www.googleapis.com/auth/gmail.readonly https://www.googleapis.com/auth/gmail.addons.current.message.metadata https://www.googleapis.com/auth/gmail.addons.current.message.readonly https://www.googleapis.com/auth/gmail.addons.current.message.action&redirect_uri=https://devtheone.pereless.com:8443/v1/index.cfm/googlecallback&response_type=code&client_id=96866548193-g8kll1a3kp0afp2vjj3k5jcia0k0gqnq.apps.googleusercontent.com&access_type=online`)
  }
}
